import React from "react";
import PropType from "prop-types";
import { DateTime as Luxon } from "luxon";

import Icon from "components/Icon";
import { playgroundTypes } from "domain/Directories/types";
import { isLuxonDayEquals } from "lib/datetime";
import { noop } from "lodash-es";
import { getPeriodicity } from "domain/Directories/selectors";
import { Tooltip as ReactTooltip } from "react-tooltip";
import StationRow from "components/StationRow";

const ConditionsFirst = ({
    startsAt,
    duration,
    playground,
    handleClickPlayground,
    cost,
    currency,
    showCost,
    isRegular,
    periodicity,
    level,
    paymentMethod,
    isPaySuccess,
}) => {
    const startDateTime = Luxon.fromSQL(startsAt);
    const now = Luxon.local();

    let StartDate = startDateTime.setLocale(`ru`).toFormat("d MMMM");

    if (isLuxonDayEquals(startDateTime, now)) {
        StartDate = "Сегодня";
    }

    if (isLuxonDayEquals(startDateTime, now.plus({ days: 1 }))) {
        StartDate = "Завтра";
    }

    return (
        <div className="card-full__conditions-first">
            <ul className="conditions card-full__block">
                <li className="conditions__item">
                    <span className="conditions__icon-container icon-container">
                        <Icon type={`calendar`} inheritColor />
                    </span>

                    <div className="conditions__right-col">
                        <p className="fs-body1 c-gs-medium-em">
                            {isRegular
                                ? getPeriodicity[periodicity]
                                : StartDate}
                        </p>
                        <p className="fs-caption c-gs-label">
                            {`${startDateTime.toLocaleString(
                                Luxon.TIME_24_SIMPLE
                            )} - ${startDateTime
                                .plus({ minutes: duration })
                                .toLocaleString(Luxon.TIME_24_SIMPLE)}`}
                        </p>
                    </div>
                </li>

                <li
                    className="conditions__item"
                    style={{ cursor: "pointer" }}
                    onClick={handleClickPlayground}
                >
                    <span className="conditions__icon-container icon-container">
                        <Icon type={`location`} inheritColor />
                    </span>

                    <div className="conditions__right-col">
                        <p className="fs-body1 c-gs-medium-em">
                            {playground.name}
                        </p>
                        <p className="fs-caption c-gs-label">
                            {playground.address}
                        </p>
                    </div>
                </li>

                {playground?.stations?.length > 0 && (
                    <li
                        className="conditions__item"
                        style={{ cursor: "pointer" }}
                        onClick={handleClickPlayground}
                    >
                        <span className="conditions__icon-container icon-container">
                            <Icon type="underground" inheritColor />
                        </span>

                        <div className="conditions__right-col station station_detail">
                            <p className="fs-body1 c-gs-medium-em">Метро</p>
                            {playground?.stations?.map((station, key) => (
                                <StationRow
                                    className="fs-body1 c-gs-medium-em"
                                    color={station?.metro_line?.color}
                                    title={station.name}
                                    id={station.id}
                                    key={key}
                                />
                            ))}
                        </div>
                    </li>
                )}

                {level?.name && (
                    <li className="conditions__item">
                        <span className="conditions__icon-container icon-container">
                            <Icon type="star" inheritColor />
                        </span>

                        <div className="conditions__right-col">
                            <p className="fs-body1 c-gs-medium-em">
                                {level?.name}
                            </p>
                        </div>

                        {level?.description && (
                            <Icon
                                type="info"
                                className="level-info"
                                data-tooltip-content={level?.description}
                                data-tooltip-id={`level-name`}
                            />
                        )}
                    </li>
                )}

                {level?.description && (
                    <div className="tooltip">
                        <ReactTooltip
                            id="level-name"
                            className="tooltip-react-level-type"
                        />
                    </div>
                )}

                {showCost && (
                    <li className="conditions__item">
                        <span className="conditions__icon-container icon-container">
                            <Icon type={`wallet`} inheritColor />
                        </span>

                        <div className="conditions__right-col">
                            <p className="fs-body1 c-gs-medium-em">
                                {cost > 0
                                    ? `${
                                          cost !== 0 ? Math.ceil(cost / 100) : 0
                                      } ${currency}`
                                    : `Бесплатно`}
                            </p>
                            <p className="fs-caption c-gs-label">
                                {paymentMethod}
                            </p>
                            {isPaySuccess && (
                                <p className="paid btn--text text-uppercase">
                                    Оплачено
                                </p>
                            )}
                        </div>
                    </li>
                )}
            </ul>
        </div>
    );
};

ConditionsFirst.defaultProps = {
    showCost: true,
    handleClickPlayground: noop,
};

ConditionsFirst.propTypes = {
    startsAt: PropType.string.isRequired,
    duration: PropType.number.isRequired,
    playground: playgroundTypes.isRequired,
    handleClickPlayground: PropType.func,
    cost: PropType.number,
    showCost: PropType.bool,
    isRegular: PropType.bool,
    periodicity: PropType.string,
    level: PropType.object,
    currency: PropType.string,
    paymentMethod: PropType.string,
    isPaySuccess: PropType.bool,
};
export default ConditionsFirst;
